import {GqlModel, GqlModelOperator, GqlQueryModel} from "../graphql/graphql.model";
import gql from "graphql-tag";
import {jsonProperty} from "../json.model";
import {ErrorItemModel} from "../misc/error-item.model";

export interface ItsmPurchaseOrderModel {
  purchaseOrderNumber: string;
  purchaseOrderDescription: string;
  purchaseOrderITSMId: string;
  createdOn: Date;
  dartOffers: {productId: string, description: string}[];
  purchaseOrderId: string;
  monthlyPo?: boolean;
}

export interface PurchaseOrderModel {
  purchaseOrderId: string;
  purchaseOrderNumber: string;
  purchaseOrderDescription: string;
  purchaseOrderITSMId: string;
  createdOn: Date;
  perSignedSOW: boolean;
  pendingPO: boolean;
  dartOffers: DartOfferModel[];
  opportunityId: string;
  monthlyPo?: boolean;
}

export interface DartOfferModel {
  offerNumber: string;
  offerDescription: string;
}

export enum PurchaseOrderCategory {
  customerPO = "customerPO",
  pendingPO = "pendingPO",
  perSignedSow = "perSignedSow",
  monthlyPO = "MOPO",
}

export function itsmPurchaseOrderModelFactory(json?: any): ItsmPurchaseOrderModel {
  json = json || {};

  return {
    purchaseOrderId: json.id || null,
    purchaseOrderNumber: json.purchaseOrderNumber || "",
    purchaseOrderITSMId: json.purchaseOrderITSMId || json.purchaseOrderId || json.itsmId || null,
    purchaseOrderDescription: json.description || json.purchaseOrderDescription || "",
    dartOffers: json.dartOffers || [],
    createdOn: json.createdOn ? new Date(json.createdOn) : "",
    monthlyPo: json.monthlyPo || false,
  } as ItsmPurchaseOrderModel;
}

export function dartOffersModelFactory(json?: any): DartOfferModel {
  json = json || {};
  return {
    offerNumber: json.offerNumber || "",
    offerDescription: json.offerDescription || "",
  } as DartOfferModel;
}

export function purchaseOrderModelFactory(json?: any): PurchaseOrderModel {
  json = json || {};

  return {
    purchaseOrderId: json.purchaseOrderId || json.id || null,
    purchaseOrderNumber: json.purchaseOrderNumber || "",
    purchaseOrderDescription: json.purchaseOrderDescription || json.description || "",
    purchaseOrderITSMId: json.purchaseOrderITSMId || json.itsmId || "",
    createdOn: json.createdOn ? new Date(json.createdOn) : "",
    perSignedSOW: json.perSignedSOW || false,
    pendingPO: json.pendingPO || false,
    dartOffers: dartOffersModelListFactory(json.dartOffers || [{}]),
    opportunityId: json.opportunityId || null,
    monthlyPo: json.monthlyPo || false,
  } as PurchaseOrderModel;
}

export function dartOffersModelListFactory(json?: any): DartOfferModel[] {
  return Array.from(json.length ? json : [{}]).map(it => dartOffersModelFactory(it));
}
export function purchaseOrderModelListFactory(json?: any): PurchaseOrderModel[] {
  return Array.from(json || []).map(it => purchaseOrderModelFactory(it));
}

export function itsmPurchaseOrderModelListFactory(json?: any): ItsmPurchaseOrderModel[] {
  return Array.from(json || []).map(it => itsmPurchaseOrderModelFactory(it));
}

export function arePurchaseOrdersEqual(po1: PurchaseOrderModel, po2: PurchaseOrderModel): boolean {
  return (!!po1.purchaseOrderITSMId && po1.purchaseOrderITSMId === po2.purchaseOrderITSMId) ||
    (!!po1.purchaseOrderId && po1.purchaseOrderId === po2.purchaseOrderId) ||
    (
      !!po1.purchaseOrderNumber && po1.purchaseOrderNumber === po2.purchaseOrderNumber &&
      !!po1.purchaseOrderDescription && po1.purchaseOrderDescription === po2.purchaseOrderDescription
    );
}

export class PurchaseOrderStatusGqlModel extends GqlQueryModel {
  static mapper: GqlModelOperator<PurchaseOrderStatusGqlModel> = GqlModel.buildMapper(PurchaseOrderStatusGqlModel, "purchaseOrderBrokerStatus");

  static query: any = gql`
      subscription purchaseOrderBrokerStatus($projectId: ID!, $transactionId: ID!) {
          purchaseOrderBrokerStatus(projectId: $projectId, transactionId: $transactionId) {
              __typename
              ... on PurchaseOrderBrokerStatus {
                  status
                  messages {
                      message
                      property
                  }
              }
          }
      }
  `;

  static variables(projectId: string, transactionId: string) {
    return {projectId, transactionId};
  }

  @jsonProperty("string") status: string;
  @jsonProperty([ErrorItemModel]) messages: ErrorItemModel[];

  constructor(data: any) {
    super(data);
  }
}
